module.exports = __webpack_public_path__ + "static/media/menu-2.7bb2ab0a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/menu-2.jpg
// module id = 154
// module chunks = 0